import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import CategoryList from './pages/CategoryList';
import ChildCategoryList from './pages/ChildCategoryList';
import TestList from './pages/TestList';
import TestPractice from './pages/TestPractice';
import UserManagementPage from './pages/UserManagementPage';
import AdminImportPage from './pages/AdminImportPage';
import AdminCategoryManagementPage from './pages/AdminCategoryManagementPage';
import './App.css';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
    const { isAuthenticated } = useAuth();
    return isAuthenticated ? children : <Navigate to="/login" />;
};

// Admin Route Component (requires authentication AND admin role)
const AdminRoute = ({ children }) => {
    const { isAuthenticated, isAdmin } = useAuth();
    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }
    if (!isAdmin) {
        return <Navigate to="/categories" />;
    }
    return children;
};

// Main App Routes
const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route 
                path="/categories" 
                element={
                    <ProtectedRoute>
                        <CategoryList />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/categories/:parentId/children" 
                element={
                    <ProtectedRoute>
                        <ChildCategoryList />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/tests" 
                element={
                    <ProtectedRoute>
                        <TestList />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/test/:testId" 
                element={
                    <ProtectedRoute>
                        <TestPractice />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/admin/users" 
                element={
                    <AdminRoute>
                        <UserManagementPage />
                    </AdminRoute>
                } 
            />
            <Route 
                path="/admin/import" 
                element={
                    <AdminRoute>
                        <AdminImportPage />
                    </AdminRoute>
                } 
            />
            <Route 
                path="/admin/categories" 
                element={
                    <AdminRoute>
                        <AdminCategoryManagementPage />
                    </AdminRoute>
                } 
            />
            <Route path="/" element={<Navigate to="/categories" />} />
        </Routes>
    );
};

const App = () => {
    return (
        <AuthProvider>
            <Router>
                <AppRoutes />
            </Router>
        </AuthProvider>
);
};

export default App;
